import { useEffect, useState } from "react";
import { request } from "../api/client";
export type Period = { periodId:string; label:string; unit:string; count:number; active:boolean; version:number };
export type CatalogueProduct = { productId:string; name:Record<string,string>; purchaseMode:"ONE_TIME"|"SUBSCRIPTION"; status:string; version:number; pricingSource?:"NATIVE"|"LEGACY"; periods:Period[] };
export type Page<T> = { items:T[]; nextCursor:string|null };
export function useCataloguePage<T>(path:string, revision=0) {
  const [page,setPage]=useState<Page<T>>(), [error,setError]=useState<unknown>();
  useEffect(()=>{const c=new AbortController();setPage(undefined);setError(undefined);
    void request<Page<T>>(path,"GET",undefined,c.signal).then(p=>{if(!Array.isArray(p.items)||p.items.length>50)throw new Error("Invalid catalogue page");if(!c.signal.aborted)setPage(p);}).catch(e=>{if(!c.signal.aborted)setError(e);});return()=>c.abort();
  },[path,revision]);return {page,error};
}
export function usePeriods(revision=0) {
  const [items,setItems]=useState<Period[]>(),[error,setError]=useState<unknown>();
  useEffect(()=>{const c=new AbortController();setItems(undefined);setError(undefined);void(async()=>{
    let cursor="";const all:Period[]=[];const seen=new Set<string>();
    do {const p=await request<Page<Period>>("/catalogue/periods?"+new URLSearchParams({cursor}),"GET",undefined,c.signal);
      if(!Array.isArray(p.items)||all.length+p.items.length>1000||p.nextCursor&&seen.has(p.nextCursor))throw new Error("Invalid period catalogue");
      all.push(...p.items);cursor=p.nextCursor||"";seen.add(cursor);
    }while(cursor);if(!c.signal.aborted)setItems(all);
  })().catch(e=>{if(!c.signal.aborted)setError(e);});return()=>c.abort();},[revision]);return {items,error};
}
